import React, { useEffect, useRef, useState } from "react";
import { GetASDCXC2, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../../Actions/GetContainer";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import { NombreMes } from "../../Helper/NombreMes";

export const FiltroRotacionCXC2 = ({
    children,
    updateBoxState,
    onBoxChange,
    boxState,
    BoxClick,
    OnIniciar,
    dejercicio = 'flex',
    dmesfin = "flex",
    titulo = '',
    titulo_filtro,
    subtitulo = '',
    cargarADR = true,
    cargarDepartamento = false,
    cargarSucursal = true,
    cargarfiltros = true,
    usuariodefault = null,
    ejercicioPersistente = 0,
    periodoPersistente = 0,
    filtroInicial = null,
}) => {
    const loadingRef = useRef();
    const loadingCargandoRef = useRef();
    const loadingErrorRef = useRef();
    const año = new Date().getFullYear();
    const mesActual = new Date().getMonth() + 1;
    const [stateError, setError] = useState("");

    const [fechas, setFechas] = useState({}); // { 2025: [1,2,...], 2026: [1,2,...] }

    const [state, setstate] = useState({
        data: [],
        filtro: [],
        ejercicioinicio: ejercicioPersistente !== 0 ? periodoPersistente : año,
        ejerciciofin: año,
        periodoinicio: mesActual,
        periodofin: periodoPersistente !== 0 ? periodoPersistente : mesActual,
        tsucursal: '',
        tdeptos: ''
    });

    const { data, filtro, ejercicioinicio, periodofin } = state;
    const meses = [1,2,3,4,5,6,7,8,9,10,11,12];

    const GetChildren = (key) => {
        if (children === undefined || children === null)
            return <></>
        if (Array.isArray(children)) {

            var result = children.filter(x => x.key === key);
            if (result !== undefined && result !== null && result.length > 0) {
                return result[0]
            }
        }
        if (children.key === key)
            return children;

        return <></>
    }

    useEffect(() => {
        onClose();
        if (cargarfiltros)
            GetASDCXC2(usuariodefault)
                .then((res) => {
                    const fechasAgrupadas = res.fechas.reduce((acc, item) => {
                        if (!acc[item.ejercicio]) acc[item.ejercicio] = [];
                        acc[item.ejercicio].push(item.periodo);
                        return acc;
                    }, {});
                    setFechas(fechasAgrupadas);

                    const periodosAñoActual = res.fechas
                        .filter(f => Number(f.ejercicio) === Number(año))
                        .map(f => Number(f.periodo));

                    const ultimoPeriodo =
                        periodosAñoActual.length > 0
                            ? Math.max(...periodosAñoActual)
                            : mesActual;

                    const periodoFinal = periodoPersistente !== 0 ? periodoPersistente : ultimoPeriodo;
                    const ejercicioFinal = ejercicioPersistente !== 0 ? ejercicioPersistente : año;

                    const filtroCalculado = res.filtro.map((x, index) => ({
                        id: x.id,
                        tipo_ubi: x.tipo_ubi,
                        descripcion: x.descripcion,
                        checked: filtroInicial
                            ? x.id === filtroInicial.id && x.tipo_ubi === filtroInicial.tipo_ubi
                            : index === 0
                    }));

                    setstate((prev) => ({
                        ...prev,
                        data: res.filtro,
                        filtro: filtroCalculado,
                        periodofin: periodoFinal,
                        ejercicioinicio: ejercicioFinal,
                    }));

                    const filtroSeleccionado = filtroCalculado.find(x => x.checked);

                    onBoxChange((prev) => ({
                        ...prev,
                        periodofin: periodoFinal,
                        ejercicioinicio: ejercicioFinal,
                        filtro: filtroCalculado.filter(x => x.checked)
                    }));

                    OnIniciar(ejercicioFinal, periodoFinal, filtroSeleccionado);
                })
                .catch((err) => console.log(err));
    }, []);

    useEffect(() => {
        if (state.filtro.length > 0) {
            const selected = state.filtro.filter(x => x.checked);
            onBoxChange("filtro", selected);
        }
    }, [state.filtro]);



    const onChange = ({ target }) => {
        setstate({
            ...state,
            [target.name]: target.value,
        });
        onBoxChange(target.name, target.value);
    };

    const onClick = () => {
        const element = document.getElementById("box-structure-bussiness-filtros-2");
        if (element !== undefined && element !== null) {
            element.style.display = "flex";
        }
    };
    const onClose = () => {
        const element = document.getElementById("box-structure-bussiness-filtros-2");
        if (element !== undefined && element != null) {
            element.style.display = "none";
        }
        closeConsulta();
    };
    const closeConsulta = () => {
        if (loadingRef.current !== undefined && loadingRef.current != null)
            loadingRef.current.style.display = "none";
        if (
            loadingCargandoRef.current !== undefined &&
            loadingCargandoRef.current !== null
        )
            loadingCargandoRef.current.style.display = "flex;";
        if (loadingErrorRef.current !== undefined && loadingErrorRef.current != null)
            loadingErrorRef.current.style.display = "none";
    };
    const onFiltroChange = (index) => {
        const copy = state.filtro.map((item, i) => ({
            ...item,
            checked: i === index // 👈 SOLO UNO
        }));

        setstate(prev => ({
            ...prev,
            filtro: copy
        }));

        onBoxChange(
            "filtro",
            copy.filter(x => x.checked) // solo 1 elemento
        );
    };
    const consultar = () => {
        BoxClick(state.ejercicioinicio, state.periodofin)
            .then(() => {
                onClose();
            })
            .catch((err) => {
                if (
                    loadingErrorRef.current !== undefined &&
                    loadingErrorRef.current !== null
                ) {
                    loadingCargandoRef.current.style.display = "none";
                    loadingErrorRef.current.style.display = "flex";
                    setError(JSON.stringify(err));
                }
            });
    };

    // console.log(state)

    return (
        <>
            <div className='encabezado-reports-filtros-2'>
                <div>
                    <div className='filtro-titulo'>
                        <button className="boton-box-structure" onClick={onClick}>
                            Filtro
                        </button>
                        <header>
                            <div className="titulo">{titulo}</div>
                            <div className="sub-titulo">{subtitulo}</div>
                        </header>
                    </div>
                </div>
                {
                    GetChildren('box-actions')
                }
            </div>
            <div id="box-structure-bussiness-filtros-2" key="box-structure-bussiness-filtros-2">
                <div className="filtro-soy-el-titulo">
                    <div className="filtro-soy-el-titulo-header">
                        {titulo_filtro}
                        <span className="filtro-soy-span-close" onClick={onClose}>
                            X
                        </span>
                    </div>
                    <div className="filtro-soy-el-titulo-line">
                        <div className="filtro-soy-el-titulo-line-bl"></div>
                        <div className="filtro-soy-el-titulo-line-circle"></div>
                        <div className="filtro-soy-el-titulo-line-br"></div>
                    </div>
                </div>
                <div className="box-action-container-filtros">
                    <div className="filtro-tiempo-tipo">
                        <div className="filtro-group" style={{ display: dejercicio }}>
                            <label>Ejercicio</label>
                            <select
                                className="select-ejercicio"
                                name={"ejercicioinicio"}
                                value={ejercicioinicio}
                                onChange={onChange}
                            >
                                <option value={0}>Seleccionar...</option>
                                {Object.keys(fechas).map((ej) => (
                                    <option key={ej} value={ej}>{ej}</option>
                                ))}
                            </select>
                        </div>

                        <div className="filtro-group" style={{ display: dmesfin }}>
                            <label>Periodo</label>


                            <select
                                name={"periodofin"} value={periodofin} onChange={onChange}
                            >
                                <option value="0">Seleccionar...</option>
                                {meses?.map((p) => (
                                    <option key={p} value={p}>{NombreMes(p)}</option>
                                ))}
                            </select>
                        </div>

                        {
                            GetChildren('box-filtro')
                        }

                        <div className="box-filtros-container-buttons">
                            <button className="button-accept" onClick={consultar}>
                                Cargar
                            </button>
                        </div>
                    </div>
                    {cargarfiltros === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-general">
                            <div className="title">Filtro</div>

                            {filtro.map((item, index) => (
                                <div key={item.id} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        checked={item.checked || false}
                                        onChange={() => onFiltroChange(index)}
                                    />
                                    <label>
                                        {capitalizePalabras(item.descripcion)}
                                    </label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
